import Cookies from 'js-cookie';

import { handleResponseError, initialState, rootDomain } from '@/Helpers.js';
import CourseEnrollment from '@/models/CourseEnrollment.js';
import EnrollmentGroupColor from '@/models/EnrollmentGroupColor.js';
import LtiToolDeployment from '@/models/LtiToolDeployment.js';
import UserSetting from '@/models/UserSetting.js';
import store from '@/store/Index.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';

export default class InitialStateLoader {
    static async loadUserEnrollments(forceApi = false) {
        const userEnrollments = initialState('UserEnrollments', { data: [] }).data || [];

        if (userEnrollments.length && !forceApi) {
            await CourseEnrollment.insert({ data: userEnrollments });
        } else if (store.getters['Auth/check']) {
            try {
                const queryBuilder = new QueryBuilder('user-enrollments').include([
                    'course.sections',
                    'course.gradebook',
                ]);

                await CourseEnrollment.api().get(queryBuilder.toUrl(), store.getters.deviceAssetHeader);
            } catch (e) {
                handleResponseError(e);
            }
        }
    }

    static async loadUserSettings() {
        return UserSetting.insert({
            data: initialState('UserSettings'),
        });
    }

    static async loadLtiToolDeployments() {
        return LtiToolDeployment.insert({
            data: initialState('LtiToolDeployments'),
        });
    }

    static loadEnrollmentGroupColors() {
        return EnrollmentGroupColor.insert({
            data: initialState('EnrollmentGroupColors', []),
        });
    }

    static loadCloudfrontSignedCookies() {
        const cookies = initialState('CloudfrontSignedCookies', {});

        if (Object.keys(cookies).length) {
            Object.entries(cookies).forEach(([key, value]) => {
                Cookies.set(key, value, { domain: `.${rootDomain(initialState('AppHost'))}` });
            });
        }
    }
}
